// src/pages/About.js
import React from 'react';
import '../styles/LittleChiefStyle.css';
import lukeImage from '../static/images/LukeLittleChief.png';


function About() {
    return (
        <div className="outer-about-container">
            <div className="page-headline" id="about-title">
                <h1>About Luke Little Chief</h1>
            </div>
        <div className="about-container">
            <div className="image-container">
                <img id="luke-image" src= {lukeImage} alt={"Luke Little Chief"}/>
            </div>
            <div className="text-container">
                <p>
                    Born and raised in Calgary, Little Chief is an Indigenous hip-hop artist from the Siksika Nation. As a member of the Tribe Artists Society, a Calgary-based hip-hop collective, Little Chief has carved out a unique space in the music world, where his art serves as both a personal narrative and a powerful commentary on the experiences of Indigenous peoples in urban environments.
                </p>
                <p>
                    Blending high-energy lyricism, storytelling, and spoken word poetry, Little Chief’s work delves deep into the challenges and triumphs of navigating city life as an Indigenous person. His music and performances are not just about rhythm and rhyme but about preserving and amplifying the voices of those who have often been marginalized. Through his artistry, he captures the complexities of identity, culture, and community, offering listeners an authentic glimpse into the struggles and resilience of Indigenous peoples.

                </p>
            </div>
        </div>
        </div>
    );
}

export default About;